import React, { useState } from 'react';
import TableItem from './TableItem';

export default function CleItem({
  item, isAdmin, academySubscription, subscription,
}) {
  const [statesVisible, setStatesVisible] = useState(false);
  const [showAllStates, setShowAllStates] = useState(false);
  const isCompleted = Number(item?.max_progress) > 0.9;
  const renderStates = (states) => {
    if (showAllStates || states.length < 10) return states?.map((s) => s.name).join(', ');
    if (states.length === 55) return 'All Jurisdictions';

    return (
      <>
        { states.slice(0, 10).map((s) => s.name).join(', ') }
        <span
          onClick={() => setShowAllStates(true)}
          className="more-button"
        >
          {` and ${states.length - 10} more`}
        </span>
      </>
    );
  };

  return (
    <div className="row" key={item.id} style={{ paddingTop: '1.2rem' }}>
      <TableItem
        data={item.media_item}
        isAdmin={isAdmin}
        isAcademy={academySubscription}
        subscription={subscription}
      />
      <div className="cle-data">{`${item?.media_item?.cle_credits} credits`}</div>
      <div className="cle-data">{`${item?.media_item?.content_length_minutes} minutes`}</div>
      <div
        className="cle-data"
        onMouseEnter={() => setStatesVisible(true)}
        onMouseLeave={() => setStatesVisible(false)}
      >
        <span style={{ cursor: 'pointer' }}>
          {`${item?.media_item?.cle_jurisdictions?.length} jurisdictions`}
        </span>
        { statesVisible && (
          <div className="cle-states">
            {renderStates(item.media_item.cle_jurisdictions)}
          </div>
        )}
      </div>
      <div className="cle-data">
        { isCompleted ? 'Completed' : `${(Number(item?.max_progress) * 100).toFixed(2)} %` }
      </div>
    </div>
  );
}
